module.exports = __webpack_public_path__ + "img/8.96b54d99.jpg";